/** @format */

import {
  DomSanitizer,
  SafeHtml,
  SafeResourceUrl,
  SafeScript,
  SafeStyle,
  SafeUrl,
} from '@angular/platform-browser';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { Logger } from '@shared/data-access/services';

@Pipe({
  standalone: true,
  name: 'bypassSanitization',
})
export class BypassSanitizationPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly logger = inject(Logger);

  public transform(
    value: string,
    type = 'html',
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl | undefined {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        this.logger.error(`BypassSanitizationPipe: Invalid safe type specified: ${type}`);
    }
  }
}
